//@flow
import React from 'react';
import css from './submenu-desktop.css';
import {
  Link
} from 'react-router-dom'
import {
  Actions
} from './actions'
// import ImageProvider from 'lib/image-provider';
// import iddLogo from 'img/idd-logo-white.png';
class SubMenuDesktop extends React.Component < * > {
  handleClick(e: SyntheticInputEvent < * > ) {
    Actions.setShowMenu(false)
  }


  render() {
    let items = [];
    Object.entries(this.props.items).forEach(([k, v]) => {
      if (typeof v === 'string') {
        items.push(<Link key={k} onClick={(e)=>this.handleClick(e)} to={v} className={css.link}>{k}</Link>);
      } else if (typeof v === 'function') {
        items.push(<Link key={k} onClick={v} to="#" className={css.link}>{k}</Link>);
      }
    })

    let position = this.props.store.get('showMenu') ? css.show : css.hide;
    let fade = this.props.store.get('showMenu') ? css.in : css.out;
    return <div><div className={[css.shadow,fade].join(" ")} onClick={(e)=>this.handleClick(e)}></div>
    <div className={[css.container,position].join(" ")}>
      <Link className={css.logo} onClick={(e)=>this.handleClick(e)} to="/" >
        {/* <img  src={iddLogo} alt='logo'/> */}
</Link>

{items}
    </div>
  </div>;
  }
}
export default SubMenuDesktop;